import axios from 'axios';
import {EnvVarsValues} from './envVarsValues';
import {parseValuesWithFallbacks} from './helpers';

// Store ENV_CONFIG on global object so it persists across module resets in tests
// If we don't do this, using this variable as a local variable, jest will
// reset it every time. leading to errors.
declare global {
  var __ENV_CONFIG__: EnvVarsValues | undefined;
}

async function tryGetJSONFile() {
  try {
    const response = await axios.get<EnvVarsValues>('/configs/env.json');
    return response.data;
  } catch {
    console.info('env.json not found or failed to load, using process.env fallback');
  }
}

export async function loadEnvVars() {
  const jsonFileContent = await tryGetJSONFile();
  const finalValues = parseValuesWithFallbacks(jsonFileContent);
  globalThis.__ENV_CONFIG__ = finalValues;
}

export function loadEnvVarsForTest(defaults?: Partial<EnvVarsValues>) {
  const finalValues = parseValuesWithFallbacks(defaults);
  globalThis.__ENV_CONFIG__ = finalValues;
}

export function getEnvVars() {
  if (!globalThis.__ENV_CONFIG__) {
    throw new Error('ENV_CONFIG not loaded. Call loadEnvVars() or loadEnvVarsForTest() first.');
  }
  return globalThis.__ENV_CONFIG__;
}

export function getEnvVar(key: keyof EnvVarsValues) {
  if (!globalThis.__ENV_CONFIG__) {
    throw new Error('ENV_CONFIG not loaded. Call loadEnvVars() or loadEnvVarsForTest() first.');
  }
  return globalThis.__ENV_CONFIG__[key];
}
